
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiClearPolartwilight as ObiClearPolartwilightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-clear-polartwilight.js';
 
 
 

 
 export const ObiClearPolartwilight = createComponent({
   react: React,
   tagName: 'obi-clear-polartwilight',
   elementClass: ObiClearPolartwilightElement,
   events: {
     
   }
  });
 
 